import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import CgPopover from 'modules/Common/ui/CgPopover';
import CbamCostBreakdown from './CbamCostBreakdown';
import { formatCurrency as formatSharedCurrency } from 'helpers/numberFormat';

const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '-';
  return formatSharedCurrency(value, {
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * The CBAM premium cell shown in both portal product tables: the €/t figure
 * with a calculator affordance, opening the shared cost breakdown.
 *
 * The operator preview and the public share page rendered byte-identical copies
 * of this, differing only in how the popover opens — hover suits a dense
 * authenticated table, click suits the public page (and touch). That stays a
 * prop; everything else is shared, so the two surfaces can't drift on how a
 * premium is presented.
 *
 * `see` / `sefa` / `cost` come from `utils/costMath.computeRowCost` — this
 * component derives nothing.
 */
export default function PortalCostCell({
  cost,
  base,
  sefa,
  isDirectOnly,
  carbonPrice,
  trigger = 'hover',
}) {
  return (
    <CgPopover
      trigger={trigger}
      position="top"
      maxWidth="max-w-[420px]"
      triggerElement={
        <span className="inline-flex items-center gap-1.5 cursor-help">
          <span className="text-sm font-semibold text-gray-900">{formatCurrency(cost)}</span>
          <span className="text-[11px] text-gray-500">/t</span>
          <span className="text-primaryColor">
            <FontAwesomeIcon
              icon={faCalculator}
              className="text-xs"
            />
          </span>
        </span>
      }
      popoverContent={
        <CbamCostBreakdown
          see={base}
          basisLabel={isDirectOnly ? 'Direct SEE' : 'Total SEE'}
          sefa={sefa}
          carbonPrice={carbonPrice}
          cost={cost}
        />
      }
    />
  );
}
